
import { classifyBookingOwner } from '@client/shared/lib/booking-owner.ts';

export function agentIdSuffix(agentUserId: string): string {
  return `Agent · ${agentUserId.slice(0, 8)}`;
}

export function agentDisplayLabel(
  agentUserId: string | null | undefined,
  viewerUserId: string | null | undefined,
  nameMap: ReadonlyMap<string, string> | undefined,
): string | null {
  if (agentUserId == null) return null;
  if (classifyBookingOwner(agentUserId, viewerUserId) === 'mine') return 'You';
  const name = nameMap?.get(agentUserId)?.trim();
  return name || agentIdSuffix(agentUserId);
}
